import { render, staticRenderFns } from "./dataList.vue?vue&type=template&id=407fab4b&scoped=true"
import script from "./dataList.vue?vue&type=script&lang=ts"
export * from "./dataList.vue?vue&type=script&lang=ts"
import style0 from "./dataList.vue?vue&type=style&index=0&id=407fab4b&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_3bbe12a2a332147dfeceaba3e069e538/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407fab4b",
  null
  
)

export default component.exports